import { Animated } from 'react-native'
import styled from 'styled-components/native'

import { Images } from 'APP/Themes'

export const PersistentIndicator = styled(Animated.View)`
  position: absolute;
  top: 15px;
  right: 15px;
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.colors.packetLossCritical};
`

export const TempIndicator = styled(Animated.View)`
  position: relative;
  display: flex;
  flex-direction: row;
  width: 400px;
  max-width: 90%;
  align-items: center;
  justify-content: flex-start;
  padding: ${({ theme }) => theme.metrics.baseMargin}px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.packetLossCritical};
`

export const TextContainer = styled.View`
  flex: 1;
  margin-left: ${({ theme }) => theme.metrics.baseMargin}px;
`

export const Icon = styled.Image.attrs({
  source: Images.poorConnection,
})`
  width: 16px;
  height: 16px;
  tint-color: ${({ theme }) => theme.colors.darkText};
`

export const Title = styled.Text`
  font-family: ${({ theme }) => theme.fonts.fontTypes.bold};
  font-size: ${({ theme }) => theme.fonts.fontSize.regular}px;
  line-height: ${({ theme }) => theme.fonts.lineHeight.regular}px;
  color: ${({ theme }) => theme.colors.darkText};
`

export const Body = styled.Text`
  font-family: ${({ theme }) => theme.fonts.fontTypes.base};
  font-size: ${({ theme }) => theme.fonts.fontSize.caption}px;
  font-weight: normal;
  line-height: ${({ theme }) => theme.fonts.lineHeight.tiny}px;
  color: ${({ theme }) => theme.colors.darkText};
`
